import Vue from 'vue'
import VueGridLayout from 'vue-grid-layout'

Vue.use(VueGridLayout)
